<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="100"
    offset-y
    content-class="elevation-8"
  >
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <SelectSiteContainer @select-site="menu = false" />
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  masterAdminPostsPathName,
  masterAdminSitesPathName
} from '@/src/routers/masterAdmin'
import SelectSiteContainer from './SelectSiteContainer'

export default {
  name: 'SiteMenuContainer',
  components: { SelectSiteContainer },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  methods: {
    transitionSelectSite (siteKey) {
      const routeName =
        this.inSiteManagement() && this.$route.name !== masterAdminSitesPathName
          ? this.$route.name
          : masterAdminPostsPathName
      this.menu = false
      this.$router
        .push({
          name: routeName,
          params: { siteKey: siteKey }
        })
        .catch(() => {})
    },
    inSiteManagement () {
      const targetPath = this.$router.match({
        name: masterAdminSitesPathName
      }).path
      return this.$route.path.indexOf(targetPath) === 0
    }
  }
}
</script>
